/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-console */
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { requestColumns } from "./data";
import CustomTable from "../../../Core/Components/CustomTable";
import RequestIcon from "../../../Common/Svgs/RequestIcon";
import { getTableContainerHeight } from "../../../Utils/getTableContainerHeight";
import CustomPagination from "../../../Core/Components/CustomPagination";

const UssdList = ({
  currentPage,
  setCurrentPage,
  pageSize,
  setPageSize,
}) => {
  const { requestList } = useSelector((state) => state.requests);
  const { userDetails } = useSelector((state) => state.loggedInUser);

  const isSongaMobilityUser = userDetails?.isSongaMobilityUser;

  const tableContainerRef = useRef(null);

  return (
    <div
      className={`h-[calc(100vh-72px-71px-69px-40px)] ${
        requestList?.result?.length && "overflow-y-scroll"
      }`}
      ref={tableContainerRef}
    >
      <CustomTable
        disableScroll
        columns={requestColumns}
        data={isSongaMobilityUser ? requestList.result : []}
        emptyState={<RequestIcon size={16} className="text-dark-grey-text" />}
        emptyStateHeight={getTableContainerHeight(tableContainerRef)}
        rowClassName="group"
        pagination={{
          pageSize,
          total: requestList.totalRecords,
          showSizeChanger: true,
          onShowSizeChange: (current, size) => {
            setPageSize(size);
            setCurrentPage(1);
          },
          onChange: (page, size) => {
            if (size && size !== pageSize) {
              setPageSize(size);
              setCurrentPage(1);
            } else {
              setCurrentPage(page);
            }
          },
          current: currentPage,
          itemRender: (current, type, originalElement) => {
            return (
              <CustomPagination
                type={type}
                current={current}
                originalElement={originalElement}
                totalRecords={Number(requestList?.totalRecords || 0)}
              />
            );
          },
          // itemRender: (current, type, originalElement) => {
          //   const lastPage = requestList.totalRecords / current;

          //   if (type === "prev" && current === 0) {
          //     return (
          //       <button
          //         type="button"
          //         className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
          //         style={{
          //           pointerEvents: "none",
          //         }}
          //       >
          //         <ChevronIcon className="stroke-dark-gray" />
          //       </button>
          //     );
          //   }

          //   if (type === "prev" && current > 0) {
          //     return (
          //       <button
          //         type="button"
          //         className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
          //       >
          //         <ChevronIcon className="stroke-dark-gray" />
          //       </button>
          //     );
          //   }

          //   if (type === "next" && lastPage <= 10) {
          //     return (
          //       <button
          //         type="button"
          //         className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
          //         style={{ pointerEvents: "none" }}
          //       >
          //         <ChevronIcon className="stroke-dark-gray" />
          //       </button>
          //     );
          //   }

          //   if (type === "next") {
          //     return (
          //       <button
          //         type="button"
          //         className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
          //       >
          //         <ChevronIcon className="stroke-dark-gray" />
          //       </button>
          //     );
          //   }

          //   return originalElement;
          // },
        }}
      />
    </div>
  );
};

export default UssdList;
